'use client';

import { Button, Dialog, DialogPanel, Switch } from '@headlessui/react';
import classNames from 'classnames';
import { useState } from 'react';

import { customFetch } from '@/service/commonFetch';
import { useTokenStore } from '@/store/authToken';
import useMobileStore from '@/store/mobileStore';

export default function LocalUtil() {
  const { isWebView, isMobile, setDeviceInfo } = useMobileStore();
  const [isOpen, setIsOpen] = useState(false);

  const { setToken, setSsid } = useTokenStore();
  const handleSubmit = async (formData: FormData) => {
    try {
      const result = await customFetch<any>('/platform/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + process.env.PORTAL_PRIVATE_KEY,
          SSID: '3a8e3ce1-c19b-34bb-9537-0e6765e4c077',
        },
        body: JSON.stringify({
          nMemberCode: formData.get('nMemberCode'),
          userAgent: 'Iphone13', // 핸드폰 기기별 userAgent 전달
          autoLogin: false,
        }),
      });

      if (result?.data?.accessToken) {
        setToken(result.data.accessToken);
        setSsid('3a8e3ce1-c19b-34bb-9537-0e6765e4c077');
        setIsOpen(false);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  if (process.env.CURRENT_ENV !== 'local') return null;
  return (
    <div className="localSetting">
      <button
        onClick={() => setIsOpen(true)}
        style={{
          position: 'fixed',
          zIndex: 10000,
          bottom: '17px',
          right: '70px',
          height: '40px',
          background: '#fff',
          border: '1px solid gold',
        }}
      >
        로컬설정 열기
      </button>
      <Dialog open={isOpen} as="div" className="dialog_alert" onClose={setIsOpen}>
        <div className="inner pad dim">
          <DialogPanel transition className="layer_alert">
            <div className="wrap_alert">
              <dl>
                <dt>- 웹뷰여부 변경</dt>
                <dd className="detail_filter_wrap">
                  <div
                    className={classNames('switch_box', 'switch_box_primary', {
                      active: isWebView,
                    })}
                  >
                    <Switch
                      checked={isWebView}
                      onChange={(e) => {
                        setDeviceInfo({ isMobile, isWebView: e });
                      }}
                      className={classNames('switch', 'switch_primary', {
                        'switch-enabled': isWebView,
                        'switch-disabled': !isWebView,
                      })}
                    >
                      <span className="switch-button" />
                    </Switch>
                  </div>
                </dd>
                <dt>- Login</dt>
                <dd>
                  <h1 style={{ lineHeight: '100%' }}>임시로그인 처리(nMemberCode)</h1>
                  <form
                    action={handleSubmit}
                    className="wrap_input"
                    style={{ padding: '30px', display: 'flex' }}
                  >
                    <input type="text" name="nMemberCode" />
                    <button type="submit" className="btn_primary">
                      Login
                    </button>
                  </form>
                </dd>
              </dl>
            </div>
            <div className="group_btn">
              <Button
                className="btn_primary"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                확인
              </Button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </div>
  );
}
